// Thai provinces and major cities for location selection
export const thaiProvinces = [
  "Bangkok",
  "Chiang Mai",
  "Chiang Rai",
  "Phuket",
  "Pattaya",
  "Krabi",
  "Koh Samui",
  "Ayutthaya",
  "Sukhothai",
  "Kanchanaburi",
  "Hua Hin",
  "Koh Phangan",
  "Koh Tao",
  "Pai",
  "Mae Hong Son",
  "Lampang",
  "Nan",
  "Phrae",
  "Uttaradit",
  "Sukhothai",
  "Phitsanulok",
  "Phichit",
  "Phetchabun",
  "Lopburi",
  "Saraburi",
  "Nakhon Nayok",
  "Prachinburi",
  "Sa Kaeo",
  "Chachoengsao",
  "Chonburi",
  "Rayong",
  "Chanthaburi",
  "Trat",
  "Nakhon Ratchasima",
  "Buriram",
  "Surin",
  "Sisaket",
  "Ubon Ratchathani",
  "Yasothon",
  "Amnat Charoen",
  "Nong Bua Lamphu",
  "Khon Kaen",
  "Udon Thani",
  "Loei",
  "Nong Khai",
  "Maha Sarakham",
  "Roi Et",
  "Kalasin",
  "Sakon Nakhon",
  "Nakhon Phanom",
  "Mukdahan",
  "Nakhon Sawan",
  "Uthai Thani",
  "Kamphaeng Phet",
  "Tak",
  "Sukhothai",
  "Phitsanulok",
  "Phichit",
  "Phetchabun",
  "Lopburi",
  "Saraburi",
  "Nakhon Nayok",
  "Prachinburi",
  "Sa Kaeo",
  "Chachoengsao",
  "Chonburi",
  "Rayong",
  "Chanthaburi",
  "Trat",
  "Nakhon Ratchasima",
  "Buriram",
  "Surin",
  "Sisaket",
  "Ubon Ratchathani",
  "Yasothon",
  "Amnat Charoen",
  "Nong Bua Lamphu",
  "Khon Kaen",
  "Udon Thani",
  "Loei",
  "Nong Khai",
  "Maha Sarakham",
  "Roi Et",
  "Kalasin",
  "Sakon Nakhon",
  "Nakhon Phanom",
  "Mukdahan",
  "Nakhon Sawan",
  "Uthai Thani",
  "Kamphaeng Phet",
  "Tak",
  "Sukhothai",
  "Phitsanulok",
  "Phichit",
  "Phetchabun",
  "Lopburi",
  "Saraburi",
  "Nakhon Nayok",
  "Prachinburi",
  "Sa Kaeo",
  "Chachoengsao",
  "Chonburi",
  "Rayong",
  "Chanthaburi",
  "Trat",
  "Nakhon Ratchasima",
  "Buriram",
  "Surin",
  "Sisaket",
  "Ubon Ratchathani",
  "Yasothon",
  "Amnat Charoen",
  "Nong Bua Lamphu",
  "Khon Kaen",
  "Udon Thani",
  "Loei",
  "Nong Khai",
  "Maha Sarakham",
  "Roi Et",
  "Kalasin",
  "Sakon Nakhon",
  "Nakhon Phanom",
  "Mukdahan",
  "Nakhon Sawan",
  "Uthai Thani",
  "Kamphaeng Phet",
  "Tak"
];

// Education levels
export const educationLevels = [
  "High School Diploma",
  "Associate Degree",
  "Bachelor's Degree",
  "Master's Degree",
  "Doctorate (PhD)",
  "Professional Certification",
  "TEFL/TESOL Certificate",
  "Other"
];

// Common nationalities
export const nationalities = [
  "Thai",
  "American",
  "British",
  "Australian",
  "Canadian",
  "New Zealand",
  "South African",
  "Irish",
  "Scottish",
  "Welsh",
  "German",
  "French",
  "Spanish",
  "Italian",
  "Dutch",
  "Swedish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Swiss",
  "Austrian",
  "Belgian",
  "Portuguese",
  "Greek",
  "Polish",
  "Czech",
  "Hungarian",
  "Romanian",
  "Bulgarian",
  "Croatian",
  "Serbian",
  "Slovak",
  "Slovenian",
  "Estonian",
  "Latvian",
  "Lithuanian",
  "Russian",
  "Ukrainian",
  "Belarusian",
  "Japanese",
  "Korean",
  "Chinese",
  "Filipino",
  "Indonesian",
  "Malaysian",
  "Singaporean",
  "Vietnamese",
  "Cambodian",
  "Laotian",
  "Myanmar",
  "Indian",
  "Pakistani",
  "Bangladeshi",
  "Sri Lankan",
  "Nepalese",
  "Other"
];

// Years of experience options
export const experienceYears = [
  "0-1 years",
  "1-2 years",
  "2-3 years",
  "3-5 years",
  "5-7 years",
  "7-10 years",
  "10-15 years",
  "15+ years"
];
